import axios from 'axios';
import md5 from '../utils/md5';
import config from "@/config/index.js"

const app_id = config.app_id;
const app_secret = config.app_secret;

const service = axios.create({});

const request = (param) => {
	let h5DeviceId = window.localStorage.getItem("h5DeviceId");
	if (!h5DeviceId) {
		return
	}
	let time = getFamtterTimer(new Date());
	let headers = {
		user_app_id: app_id,
		user_d_id: h5DeviceId,
		user_ts: time,
		user_token: localStorage.getItem('token') || "",
		user_s: md5(`${time}${app_secret}${h5DeviceId}`)
	}
	if (param.headers) {
		Object.assign(param.headers, {
			...headers
		})
	} else {
		param.headers = {
			...headers
		}
	}
	let isDdApp = false;
	param.params = {
		"ev_type": "pageview",
		"payload": {
			...param.params,
			"p_ts": time,
			"b_id": "-",
			"c_id": "-",
			"c_name": "-",
			"a_id": "-",
			"pub_ts": "-",
			"p_c_id": "-",
			"p_c_name": "-",
			"p_type": "-",
			"p_type_id": "-"
		},
		"common": {
			"u_id": localStorage.getItem('u_id') || 0,
			"s_type": "creator",
			"env": window.location.hostname.indexOf("dingxinwen") >= 0 ? "prod" : "dev",
			"os": "PC"
		}
	}
	if (param.method != 'GET') {
		param.data = param.params;
		delete param.params;
	}

	return new Promise((resolve, reject) => {
		service(param).then((res) => {
			resolve(res)
		}).catch((err) => {
			reject(err)
		})
	})
}

function getFamtterTimer(time) {
	let date = new Date(time),
		Y = date.getFullYear(), // 年  
		M = date.getMonth() + 1, //月  
		D = date.getDate(), //日
		h = date.getHours(), //小时
		m = date.getMinutes(), //分钟
		s = date.getSeconds(); //秒数
	return Y + '-' + getZero(M) + '-' + getZero(D) + ' ' + getZero(h) + ':' +
		getZero(m) + ':' + getZero(s);

}

function getZero(num) { // 个位数前补0
	if (parseInt(num) < 10) {
		num = '0' + num;
	}
	return num;
}

export default request